import { ProductFormSystem } from './ProductFormSystem';

export default ProductFormSystem;